import apiClient from './apiClient';

export async function listPriceLists() {
  const res = await apiClient.get('/price-lists');
  return res.data.data.items;
}

export async function getPriceListOptions() {
  const res = await apiClient.get('/price-lists/options');
  return res.data.data;
}

export async function getPriceList(id) {
  const res = await apiClient.get(`/price-lists/${id}`);
  return res.data.data;
}

export async function createPriceList(doc) {
  const res = await apiClient.post('/price-lists', doc);
  return res.data.data;
}

export async function updatePriceList(id, doc) {
  const res = await apiClient.put(`/price-lists/${id}`, doc);
  return res.data.data;
}

export async function duplicatePriceList(id) {
  const res = await apiClient.post(`/price-lists/${id}/duplicate`);
  return res.data.data;
}

export async function deletePriceList(id) {
  const res = await apiClient.delete(`/price-lists/${id}`);
  return res.data.data;
}

export async function sharePriceList(id) {
  const res = await apiClient.post(`/price-lists/${id}/share`);
  return res.data.data.token;
}

export async function unsharePriceList(id) {
  const res = await apiClient.delete(`/price-lists/${id}/share`);
  return res.data.data;
}

/** The link a customer opens (no login needed). */
export function publicPriceListUrl(token) {
  let base = String(apiClient.defaults.baseURL || '/api/v1').replace(/\/+$/, '');
  if (!/^https?:\/\//i.test(base)) base = `${window.location.origin}${base.startsWith('/') ? '' : '/'}${base}`;
  return `${base}/public/price-list/${token}`;
}
